import { _ as y, E as m, D as A, N as E, c as h, O as I, q as $, L as b, b as O } from "./export-cdcbfb2b.js";
import { i as g } from "./array-iteration-759bfbfa.js";
import { i as x } from "./es.object.to-string-f55666a8.js";
import { a as P, c as T } from "./create-property-f9780ed1.js";
import { a as C } from "./array-slice-79f93c56.js";
import { d as N } from "./define-built-in-accessor-26bc7b69.js";
var _ = y, u = g, w = x, M = A, f = I, j = E, R = h, k = T, F = m, H = P, L = C, U = H("slice"), B = F("species"), s = Array, D = Math.max;
_({ target: "Array", proto: !0, forced: !U }, {
  slice: function(d, c) {
    var e = R(this), o = j(e), t = f(d, o), i = f(c === void 0 ? o : c, o), r, a, n;
    if (u(e) && (r = e.constructor, w(r) && (r === s || u(r.prototype)) ? r = void 0 : M(r) && (r = r[B], r === null && (r = void 0)), r === s || r === void 0))
      return L(e, t, i);
    for (a = new (r === void 0 ? s : r)(D(i - t, 0)), n = 0; t < i; t++, n++)
      t in e && k(a, n, e[t]);
    return a.length = n, a;
  }
});
var K = $, X = b.EXISTS, v = O, q = N, l = Function.prototype, z = v(l.toString), p = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, G = v(p.exec), J = "name";
K && !X && q(l, J, {
  configurable: !0,
  get: function() {
    try {
      return G(p, z(this))[1];
    } catch {
      return "";
    }
  }
});
